import { Box, Button } from "@mui/material";
import { AlertsProps } from "components/Alerts/data/Alerts.type";
import LoadingIndicator from "./LoadingIndicator";
import SnackbarAlert from "./SnackbarAlert";

interface LoadingAndSnackbarProps {
  loading: boolean;
  success: AlertsProps;
  handleCloseSnackBar: (state: AlertsProps) => void;
  handleSave: () => void;
}

/**
 * A React functional component that renders a save button, a loading indicator, 
 * and a snackbar alert for displaying success messages.
 *
 * @component
 * @param {LoadingAndSnackbarProps} props - The props for the component.
 * @param {boolean} props.loading - A boolean indicating whether the loading indicator should be displayed.
 * @param {boolean} props.success - A boolean indicating whether the snackbar alert should display a success message.
 * @param {() => void} props.handleCloseSnackBar - A callback function to handle closing the snackbar alert.
 * @param {() => void} props.handleSave - A callback function to handle the save button click event.
 *
 * @returns {JSX.Element} The rendered component.
 */
const LoadingAndSnackbar = ({ loading, success, handleCloseSnackBar,handleSave }: LoadingAndSnackbarProps) => {
  return (
    <>
      <Box display="flex" justifyContent="flex-end" sx={{ mt: 2 }}>
        <Button type="submit" variant="contained" data-testid="btnSave" onClick={handleSave}>
          Save
        </Button>
      </Box>
      <LoadingIndicator loading={loading} />
      <SnackbarAlert success={success} handleCloseSnackBar={handleCloseSnackBar} />
    </>
  );
};

export default LoadingAndSnackbar;

